import { Provider } from '@angular/core';

import { LazyClientConfigService } from '../lazy/lazy-client-config.service';
import { PlatformProductMapConfig, configFactory } from './platform-product-map.client-config';

export function providePlatformProductMapping(): Provider[] {
    return [{ provide: PlatformProductMapConfig, deps: [LazyClientConfigService], useFactory: configFactory }];
}
